import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { routes } from '../../../constants'
import { actions } from '../certificadoDigital.actions'
import { CertificadoDigitalForm } from './CertificadoDigitalForm'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  const record = _.cloneDeep(state.crudCertificadoDigitalState.currentRecord)
  let disableUnit = false
  const currentUnit = storage.getUnit()
  if (currentUnit) {
    const unidade = {
      id: currentUnit.oid,
      value: currentUnit.sigla,
    }
    Object.assign(record, { unidade })
    disableUnit = true
  }

  return {
    record,
    messages: state.crudCertificadoDigitalState.messages,
    uploading: state.crudCertificadoDigitalState.adicionandoAnexo,
    disableUnit,
    unidades: utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany()),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    processaCertificado: (event, password) => dispatch(actions.processaCertificado(event, password)),
  }
}

class CertificadoDigitalFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
      certificadoPassword: '',
      modoEntrada: 'certificado',
    }

    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_CERTIFICADO_DIGITAL}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CERTIFICADO_DIGITAL}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_CERTIFICADO_DIGITAL}`)
    }

    actions.beforeFetchRecordSuccess = (data) => {
      return data
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.record !== this.props.record && this.props.record.oid) {
      const completo = _.get(this.props.record, 'completo', null)
      if (completo === true || completo === false) {
        this.setState({ modoEntrada: completo ? 'certificado' : 'chaves' })
        return
      }

      const temDadosCertificado =
        _.get(this.props.record, 'dadosTitular.commonName') &&
        _.get(this.props.record, 'dadosTitular.commonName') !== 'NÃO INFORMADO'

      this.setState({ modoEntrada: temDadosCertificado ? 'certificado' : 'chaves' })
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CERTIFICADO_DIGITAL}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  onChangeField = (fieldName, value) => {
    const field = _.get(value, 'target.name', null)
    if (field === 'ativo') {
      this.props.setField(field, _.get(value, 'target.checked', null))
      return
    }
    this.props.setField(fieldName, value)
  }

  onChangeCertificadoPassword = (value) => {
    this.setState({ certificadoPassword: value })
  }

  onChangeModoEntrada = (modo) => {
    this.setState({ modoEntrada: modo })
    this.props.setField('completo', modo === 'certificado')
    
    if (modo === 'chaves') {
      this.props.setField('dadosTitular', {
        commonName: 'NÃO INFORMADO',
        organization: 'NÃO INFORMADO',
        organizationalUnit: '',
        locality: '',
        state: '',
        country: '',
        distinguishedName: '',
      })
      this.props.setField('dadosEmissor', {
        commonName: 'NÃO INFORMADO',
        organization: 'NÃO INFORMADO',
        organizationalUnit: '',
        locality: '',
        state: '',
        country: '',
        distinguishedName: '',
      })
      this.props.setField('dataInicio', null)
      this.props.setField('dataExpiracao', null)
      return
    }

    if (modo === 'certificado') {
      this.props.setField('dadosTitular', {
        commonName: '',
        organization: '',
        organizationalUnit: '',
        locality: '',
        state: '',
        country: '',
        distinguishedName: '',
      })
      this.props.setField('dadosEmissor', {
        commonName: '',
        organization: '',
        organizationalUnit: '',
        locality: '',
        state: '',
        country: '',
        distinguishedName: '',
      })
      this.props.setField('dataInicio', null)
      this.props.setField('dataExpiracao', null)
    }
  }

  onUploadCertificado = (event) => {
    this.props.processaCertificado(event, this.state.certificadoPassword)
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <CertificadoDigitalForm
        record={this.props.record}
        messages={this.props.messages}
        disableUnit={this.props.disableUnit}
        unidades={this.props.unidades}
        onChangeField={this.onChangeField}
        onUploadCertificado={this.onUploadCertificado}
        onChangeCertificadoPassword={this.onChangeCertificadoPassword}
        onChangeModoEntrada={this.onChangeModoEntrada}
        certificadoPassword={this.state.certificadoPassword}
        modoEntrada={this.state.modoEntrada}
        uploading={this.props.uploading}
      />
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CertificadoDigitalFormPageContainer)
